module.exports = __webpack_public_path__ + "static/media/logodark.05227d67.png";